import React from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

const EventName = () => {
  const { register, errors } = useFormContext()
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          What do you want to call this event?
        </Typography>
      </Box>
      <Container maxWidth="xs">
        <TextField
          name="title"
          inputRef={register}
          error={!!errors.title}
          helperText={errors.title && 'This field is required'}
          label="Event name"
        />
      </Container>
    </Box>
  )
}

export default EventName
